import { useTranslations } from 'next-intl';
import { CheckIcon, CrossIcon } from '@mentimeter/ragnar-visuals';
import type { BoxT } from '@mentimeter/ragnar-ui/box';
import { Box } from '@mentimeter/ragnar-ui/box';

export interface CorrectnessIndicatorProps extends BoxT {
  shouldShow: boolean;
  isCorrect: boolean;
  immediate: boolean;
  size: string;
}

/*
 * CorrectnessIndicator will be rendered inside a wrapper Box
 * with a set width and height to avoid layout shift when toggled.
 */
export const CorrectnessIndicator = ({
  shouldShow,
  isCorrect,
  immediate,
  size,
  ...props
}: CorrectnessIndicatorProps) => {
  const t = useTranslations('presenting');

  return (
    <Box
      data-testid="correctness-indicator"
      width={size}
      height={size}
      style={{
        opacity: shouldShow ? 1 : 0,
        transition: immediate ? 'none' : 'opacity 200ms ease',
      }}
      {...props}
    >
      <Box
        bg={isCorrect ? 'positiveWeak' : 'negativeWeak'}
        borderRadius="full"
        p="25%"
        height="100%"
        width="100%"
      >
        {isCorrect ? (
          <CheckIcon
            color="onPositiveWeak"
            size="100%"
            aria-label={t(
              'bar_chart_option_correctness_indicator_correct_a11y',
            )}
          />
        ) : (
          <CrossIcon
            color="onNegativeWeak"
            size="100%"
            aria-label={t(
              'bar_chart_option_correctness_indicator_incorrect_a11y',
            )}
          />
        )}
      </Box>
    </Box>
  );
};
